var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1693012370487,
    fill: "currentColor",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4989,
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M832 362.67m-106.67 0a106.67 106.67 0 1 0 213.34 0 106.67 106.67 0 1 0-213.34 0Z",
    "p-id": 4990
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 362.67m-106.67 0a106.67 106.67 0 1 0 213.34 0 106.67 106.67 0 1 0-213.34 0Z",
    "p-id": 4991
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192 362.67m-106.67 0a106.67 106.67 0 1 0 213.34 0 106.67 106.67 0 1 0-213.34 0Z",
    "p-id": 4992
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M832 661.33m-106.67 0a106.67 106.67 0 1 0 213.34 0 106.67 106.67 0 1 0-213.34 0Z",
    "p-id": 4993
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M512 661.33m-106.67 0a106.67 106.67 0 1 0 213.34 0 106.67 106.67 0 1 0-213.34 0Z",
    "p-id": 4994
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M192 661.33m-106.67 0a106.67 106.67 0 1 0 213.34 0 106.67 106.67 0 1 0-213.34 0Z",
    "p-id": 4995
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.c846b2fdbdf2fb099b49448d17ebf23b.svg";
export { ForwardRef as ReactComponent };